/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

/**
 * type of url
 */
export type TokenGenerateRequestType = typeof TokenGenerateRequestType[keyof typeof TokenGenerateRequestType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenGenerateRequestType = {
  tracking: 'tracking',
  routes: 'routes',
  iframe: 'iframe',
  'tracking,_routes,_iframe': 'tracking, routes, iframe',
} as const;
